/* eslint-disable */
export class LocationPage {
  constructor() {
    this.$formButton = $('.contact_aanvragen_button');
    this.$formButtonDiensten = $('.service_aanvragen_button');
    this.$formInfo = $('.brochure_aanvragen');
    this.$formInfoButton = $('#brochure_aanvragen_button');
    this.$formInfoButtonDiensten = $('.service_brochure_button');
    this.$ServiceListLink = $('.vestigingspagina_service_list a');
    this.$ServiceListMobileLink = $('.mobile_list_item a');
    this.$OpeningHoursButton = $('.vestigingspagina_opening_hours_title_mobile');
    this.$ReadMoreButton = $('.read_more_button');
    this.$ReadLessButton = $('.read_less_button');

    // bind events
    this.$formButton.on('click', e => this.formModal(e, '.contact_aanvragen'));
    this.$formButtonDiensten.on('click', e => this.selectOption(e, '.contact_aanvragen'));
    this.$formInfoButton.on('click', e => this.formModal(e, '.brochure_aanvragen'));
    this.$formInfoButtonDiensten.on('click', e => this.selectOption(e, '.brochure_aanvragen'));
    this.$formInfo.on('click', '#brochure_aanvragen_clone', () => this.formModalClone());
    this.$ServiceListLink.on('click', e => this.selectService(e));
    this.$ServiceListMobileLink.on('click', e => this.selectService(e));
    this.$OpeningHoursButton.on('click', e => this.toggleHours(e));
    this.$ReadMoreButton.on('click', e => this.readMore(e));
    this.$ReadLessButton.on('click', e => this.readLess(e));
    $(window).on('scroll', () => this.showTopBar());


    this.populateField();
    this.hideOptions('.location_products_field');
    this.selectFirstService();
  }

  /**
   * Open form in modal
   */
  formModal(e, modalClass){
    e.preventDefault();
    $(modalClass).modal('show');

  }

  formModalClone(){
    const self = this;
    $.ajax({
      url: ajax_link,
      method: 'POST',
      data: {
        action: 'load_modal_brochure',
      },
      success: function(response) {
        const container = $('.brochure_aanvragen').find('.modal-load-form');
        container.html(response);
        const currentUrl = window.location.href;
        const form = container.find('form');
        const formId = form.attr('data-formid');
        const newAction = currentUrl + '#gf_' + formId;
        form.attr('action', newAction);
        self.populateField();
      }
    });
  }

  /**
   * Select the option based on the clicked button
   * and open form in modal
   */
  selectOption(e, modalClass){
    e.preventDefault();
    if ( modalClass === '.brochure_aanvragen') {

      const target = e.target.toString();
      const brochure = target.split('=');
      $('.brochures_select select  option[value="' + brochure[2] + '"]')
        .prop('selected', true);
      let button_text = 'Download brochure';
      const services =  ['huiswerkbegeleiding', 'bijles', 'basisschoolbegeleiding'];
      if (services.includes(brochure[2])) {
        button_text += ' & tarieven inzien';
      }
      $('.opmerking_field input').val('Vanaf pagina ' + brochure[2] + ' via button: "' + button_text + '"');

      $(modalClass).modal('show').addClass('service-brochure-location');

    } else if ( modalClass === '.contact_aanvragen') {

      const service = $(e.target).attr('data-service');
      $('.location_products_field select  option[value="' + service + '"]')
        .prop('selected', true);

      $(modalClass).modal('show').addClass('service-signup-location');
    }
  }

  /**
   * Automatic populate de location id  and lead owner fields from contact form
   * Also populate ID product from brochure aanvragen
   */
  populateField() {
    const location_id = $('meta[itemProp=location_id]').attr('content');
    const product_id = this.$formInfoButton.attr('data-product_id');
    const tarieven_url = this.$formInfoButton.attr('data-tarieven');

    $('.location_id_field input').val(location_id);
    $('.product_id_field input').val(product_id);
    $('.tarieven_url_field input').val(tarieven_url);
  }

  /**
   * Hide the product options that are not available in the current location
   */
  hideOptions(field_class) {
    $(field_class + ' select option:not(:first)').hide();
    $('.vestigingspagina_service_list a').each(function(){
      let tabItem = $(this).attr('data-content').toLowerCase();
      switch (tabItem) {
        case 'het-lyceo-examenjaar':
          tabItem = 'examenjaar';
          break;
        case 'remedial-teaching-':
        case 'remedial-teaching':
          tabItem = 'remedial_teaching';
          break;
        case 'toetsweek-ondersteuningsklas':
        case 'toetsweek-ondersteuningsklas-':
          tabItem = 'intensieve_toetsweek';
          break;
      }
      $(field_class + ' select option').each(function(){
        let optionText = $(this).attr('value').toLowerCase();
        if ( optionText === tabItem ) {
          $(this).show();
        }
      });
    });
  }

  /**
   * Show the first service from the list
   */
  selectFirstService() {
    const firstService = $('.vestigingspagina_service_list a').first();
    this.showService(firstService);
  }

  /**
   * Show the chosen service from the list
   */
  selectService(e) {
    e.preventDefault();
    const element = $(e.currentTarget);
    if (element.hasClass('item_active') && element.parent('li').hasClass('mobile_list_item')) {
      this.hideService(element);
    } else {
      $('a.item_active').removeClass('item_active');
      $('.vestigingspagina_service_info_item').hide();
      this.showService(element);
    }
  }

  showService(element) {
    element.addClass('item_active');
    const itemActive = element.attr('data-content');
    $('#'+itemActive).css('display', 'flex').hide().fadeIn();
  }

  hideService(element) {
    element.removeClass('item_active');
    const itemActive = element.attr('data-content');
    $('#'+itemActive).hide('slow');
  }

  toggleHours(e) {
    const element = $(e.currentTarget);
    const list = $('.vestigingspagina_opening_hours_list');
    if ( element.hasClass('list_open') ) {
      element.removeClass('list_open');
      element.find('i').css('transform', 'rotate(0deg)');
      list.hide('slow');
    } else {
      element.addClass('list_open');
      element.find('i').css('transform', 'rotate(180deg)');
      list.show('slow');
    }
  }

  readMore(e) {
    const element = $(e.currentTarget);
    const first_part = element.parent().children('.first_part');
    const complete_text = element.parent().children('.complete_text');
    const read_less_button = element.parent().children('.read_less_button');
    element.hide();
    first_part.hide();
    complete_text.show();
    read_less_button.css('display', 'flex');
  }

  readLess(e) {
    const element = $(e.currentTarget);
    const complete_text = element.parent().children('.complete_text');
    const first_part = element.parent().children('.first_part');
    const read_more_button = element.parent().children('.read_more_button');
    element.hide();
    complete_text.hide();
    first_part.show();
    read_more_button.css('display', 'flex');
  }

  showTopBar() {
    const relativeElement = $('.vestigingspagina_coordinator_story');
    const fixedElement = $('.vestigingspagina_top_bar');

    const elementTop = relativeElement.offset().top;
    const elementBottom = elementTop + relativeElement.outerHeight();

    const viewportTop = $(window).scrollTop() + parseInt($('body').css('padding-top'), 10);
    const viewportBottom = viewportTop + $(window).height();

    if (elementBottom < viewportTop || elementTop > viewportBottom) {
      fixedElement.fadeIn();
    } else {
      fixedElement.fadeOut();
    }
  }
}
